export const setNewLog = (data) => ({
  type: 'NEW_LOG',
  payload: data,
})
